import React from 'react';
import EstadoContableReport from './EstadoContableReport';

const SituacionPatrimonial: React.FC = () => <EstadoContableReport reportType="patrimonial" />;

export default SituacionPatrimonial;
